var _path, _path2, _path3, _path4, _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgProfile = function SvgProfile(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 15C30.0007 6.71573 23.285 -2.92514e-06 15.0007 -2.56302e-06C6.71646 -2.2009e-06 0.000731404 6.71573 0.000731766 15C0.000732128 23.2843 6.71646 30 15.0007 30C23.285 30 30.0007 23.2843 30.0007 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 30.001C23.285 30.001 30.0007 23.2852 30.0007 15.001C30.0007 6.71671 23.285 0.000976563 15.0007 0.000976563C6.71646 0.000976563 0.000732422 6.71671 0.000732422 15.001C0.000732422 23.2852 6.71646 30.001 15.0007 30.001Z",
    fill: "url(#paint0_radial_115_307)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 15C30.0007 6.71573 23.285 -1.01779e-06 15.0007 -6.55671e-07C6.71646 -2.93554e-07 0.000731404 6.71573 0.000731766 15C0.000732128 23.2843 6.71646 30 15.0007 30C23.285 30 30.0007 23.2843 30.0007 15Z",
    fill: "url(#paint1_linear_115_307)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 15C30.0007 6.71573 23.285 -1.01779e-06 15.0007 -6.55671e-07C6.71646 -2.93554e-07 0.000731404 6.71573 0.000731766 15C0.000732128 23.2843 6.71646 30 15.0007 30C23.285 30 30.0007 23.2843 30.0007 15Z",
    fill: "url(#paint2_radial_115_307)",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.375 15.625H13.625C12.1668 15.6266 10.7688 16.2066 9.73772 17.2377C8.70663 18.2688 8.12664 19.6668 8.125 21.125C8.12491 21.2708 8.17114 21.4128 8.25702 21.5305C8.34291 21.6483 8.464 21.7357 8.60281 21.7802C10.6906 22.3203 12.8443 22.5627 15 22.5C17.1557 22.5627 19.3094 22.3203 21.3972 21.7802C21.536 21.7357 21.6571 21.6483 21.743 21.5305C21.8289 21.4128 21.8751 21.2708 21.875 21.125C21.8734 19.6668 21.2934 18.2688 20.2623 17.2377C19.2312 16.2066 17.8332 15.6266 16.375 15.625Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14.2498C17.1312 14.2498 18.7812 11.8642 18.7812 9.81201C18.7812 8.80916 18.3829 7.84739 17.6737 7.13826C16.9646 6.42914 16.0028 6.03076 15 6.03076C13.9972 6.03076 13.0354 6.42914 12.3263 7.13826C11.6171 7.84739 11.2188 8.80916 11.2188 9.81201C11.2188 11.8642 12.8688 14.2498 15 14.2498Z",
    fill: "#001947"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_115_307)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62503 22.4999C12.3591 22.4999 20.25 14.6089 20.25 4.87489C20.25 3.46315 20.0841 2.09017 19.7705 0.774414C25.7161 2.7674 30 8.38336 30 14.9999C30 23.2842 23.2843 29.9999 15 29.9999C9.44343 29.9999 4.59251 26.9785 2.00049 22.489C2.20778 22.4963 2.41598 22.4999 2.62503 22.4999Z",
    fill: "url(#paint3_linear_115_307)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_115_307",
    x: 0.667155,
    y: -0.558919,
    width: 30.6662,
    height: 31.8923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_115_307"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_115_307",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_115_307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9453 -4.75482e-05) rotate(135) scale(26.2404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_307",
    x1: 13.7507,
    y1: -2.5,
    x2: 0.000730471,
    y2: 17.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_115_307",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5 7.125) rotate(143.291) scale(35.5496 29.3442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_115_307",
    x1: 16.0041,
    y1: 29.9999,
    x2: 19.7477,
    y2: 8.84723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(6.75 6)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile.bc979b87.svg";
export { ForwardRef as ReactComponent };